"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInlineDescriptionEditor = exports.InlineDescriptionEditor = exports.NonFormattedMarkupWrapper = exports.inlineDescriptionViewTestId = exports.inlineDescriptionEditTestId = exports.maxCharacterLength = void 0;
const tslib_1 = require("tslib");
const catalog_messages_1 = require("@tableau/catalog-messages");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const ColumnAndFieldDetailsStyles_1 = require("./style/ColumnAndFieldDetailsStyles");
exports.maxCharacterLength = 4000;
exports.inlineDescriptionEditTestId = 'description-text-area';
exports.inlineDescriptionViewTestId = 'inline-description-view';
const InlineDescriptionTableCell = (0, vizportalclient_common_components_1.divWithStyle)('InlineDescriptionTableCell', {
    display: 'table-cell',
});
function InlineDescriptionEditor_Edit(props) {
    const { isActionBusy, editorState, setEditorStateWithinEditMode } = props.editModeLogic;
    const { message, valid } = (0, widgets_1.getMaxCharValidation)(editorState.potentialDescription, exports.maxCharacterLength);
    return (react_1.default.createElement(InlineDescriptionTableCell, null,
        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTextAreaWrapper, null, react_1.default.createElement(widgets_1.TextFormatterWidget, { label: null, disabled: isActionBusy, markup: editorState.potentialDescription, onChange: event => setEditorStateWithinEditMode({ potentialDescription: event.target.value }), previewClassName: data_catalog_shared_1.MarkupTooltipStyleClass, style: ColumnAndFieldDetailsStyles_1.columnDetailsTextAreaStyle, valid: valid, testId: exports.inlineDescriptionEditTestId, message: message })),
        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsWrapper, null,
            react_1.default.createElement(SaveAndCancelButtonsFlexWrapper, null,
                react_1.default.createElement("div", { style: { marginRight: widgets_1.TabStyles.Spacing.MediumSpace } },
                    react_1.default.createElement(vizportalclient_common_components_1.InlineEditorCancelButton, Object.assign({}, props.editModeLogic))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(vizportalclient_common_components_1.InlineEditorSaveButton, Object.assign({}, props.editModeLogic)))))));
}
const DivToRemoveSomePaddingOnThePTag = (0, vizportalclient_common_components_1.divWithStyle)('divToRemoveSomePaddingOnThePTag', {
    $nest: {
        p: {
            marginTop: 0,
            marginBottom: widgets_1.TabStyles.Spacing.SmallSpace,
        },
    },
});
function InlineDescriptionEditor_View(props) {
    const { readModeLogic, description, viewOnly } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsDescriptionValue, null,
            react_1.default.createElement("div", { style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, description
                ? (react_1.default.createElement(DivToRemoveSomePaddingOnThePTag, null,
                    react_1.default.createElement(data_catalog_shared_1.FormattedMarkupWrapperInTooltip, { markup: description, testId: exports.inlineDescriptionViewTestId })))
                : react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPlaceholder, null, catalog_messages_1.Messages.NoDescriptionAvailable()))),
        !viewOnly
            ? react_1.default.createElement(vizportalclient_common_components_1.InlineEditorEditButton, Object.assign({}, readModeLogic, { editButtonLabel: catalog_messages_1.Messages.EditDescription() }))
            : null));
}
function NonFormattedMarkupWrapper(props) {
    return react_1.default.createElement("div", { "data-tb-test-id": exports.inlineDescriptionViewTestId }, props.description);
}
exports.NonFormattedMarkupWrapper = NonFormattedMarkupWrapper;
function InlineDescriptionEditor(props) {
    const { element } = useInlineDescriptionEditor(props);
    return element;
}
exports.InlineDescriptionEditor = InlineDescriptionEditor;
function useInlineDescriptionEditor({ onSave: onSaveProp, afterSave, canEdit, initialDescription, viewOnly }) {
    const onSave = react_1.default.useCallback((editorState) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        yield onSaveProp(editorState.potentialDescription);
        if (afterSave) {
            yield (0, vizportalclient_common_components_1.delayPromise)(2000); // when this was a class component this used to be window.setTimeout(props.afterSave, 2000);
            afterSave();
        }
    }), [onSaveProp, afterSave]);
    const logic = (0, vizportalclient_common_components_1.useInlineEditor)({
        editorStateWhenEnteringEditMode: { potentialDescription: initialDescription },
        canEdit,
        onSave,
        exitEditModeOnFailedSave: true,
        canSaveFn: state => state.potentialDescription.length <= exports.maxCharacterLength
            && state.potentialDescription !== initialDescription,
    });
    return {
        element: (react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
            react_1.default.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, catalog_messages_1.Messages.Description()),
            (0, vizportalclient_common_components_1.isEditMode)(logic)
                ? react_1.default.createElement(InlineDescriptionEditor_Edit, { editModeLogic: logic })
                : react_1.default.createElement(InlineDescriptionEditor_View, { readModeLogic: logic, description: initialDescription, viewOnly: viewOnly }))),
        startEditing: () => {
            if ((0, vizportalclient_common_components_1.isReadonlyMode)(logic)) {
                logic.enterEditMode();
            }
        },
    };
}
exports.useInlineDescriptionEditor = useInlineDescriptionEditor;
const SaveAndCancelButtonsFlexWrapper = (0, vizportalclient_common_components_1.divWithStyle)('SaveAndCancelButtonsFlexWrapper', Object.assign({}, ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsFlexWrapperSharedStyle));
//# sourceMappingURL=InlineDescriptionEditor.js.map